import { render, staticRenderFns } from "./UploadMenu.vue?vue&type=template&id=0644877a&scoped=true&"
import script from "./UploadMenu.vue?vue&type=script&lang=js&"
export * from "./UploadMenu.vue?vue&type=script&lang=js&"
import style0 from "./UploadMenu.vue?vue&type=style&index=0&id=0644877a&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0644877a",
  null
  
)

export default component.exports